import request from "@/utils/requestSC";

// 添加收藏
export async function addFavorite(params) {
  // return request.post('/rest/member/favorite/batch.add', params);
  return request({
    url: "/rest/member/favorite/batch.add",
    method: "post",
    params
  });
}

// 取消收藏
export async function delFavorite(params) {
  return request({
    url: "/rest/member/favorite/del",
    method: "post",
    params
  });
  // return request.post('/rest/member/favorite/del', params);
}

// 取消收藏
export async function delRecordFavorite(params) {
  return request.post("/rest/member/favorite/record/del", params);
}

// 购物车数量
export async function getCountCart(params) {
  return request.post("/cart/getCountCart.do", params);
}

// 查询积分用户列表
export async function getPointsMemberList(params) {
  return request.post("/rest/member/getPointsMemberList", params);
}
